import { render, staticRenderFns } from "./CandidateSkills.vue?vue&type=template&id=446b7dd4&"
import script from "./CandidateSkills.vue?vue&type=script&lang=js&"
export * from "./CandidateSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports